/**
 * Created by dreamc_t on 2017/4/7.
 */
require('./eventData.scss');
var tmpl = require('./eventData.ejs');

// 线上http://api.livesports.ifeng.com // 本地接口http://10.21.7.47:8099
var apiDomain = '//api.livesports.ifeng.com';
var requestUrl = apiDomain + '/livesports/events/eventslist?'; // 事件数据
var eventlistUrl = apiDomain + '/livesports/events/eventsstatus?'; // 所有事件状态


var sportsEventData = function (info) {
    this.info = info;
    this.initEventSta = false;
};
Array.prototype.removeRepeat = function () {
    var arr = this,
        i,
        obj = {},
        result = [];
    for (i = 0; i < arr.length; i++) {
        if (!obj[arr[i].status]) { //如果能查找到，证明数组元素重复了
            obj[arr[i].status] = 1;
            result.push(arr[i]);
        }
    }
    return result;
}
sportsEventData.prototype.requestEventStatus = function () {
    return $.ajax({
        url: eventlistUrl,
        type: 'GET',
        data: {
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp'
    });
}
sportsEventData.prototype.requestData = function () {
    var _this = this;
    return $.ajax({
        url: requestUrl,
        type: 'GET',
        data: {
            mid: _this.info.matchId,
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp'
    });

};

sportsEventData.prototype.endPolling = function (timer) {
    clearTimeout(timer);
}
sportsEventData.prototype.setTimeForData = function () {
    clearTimeout(this.timerForEvent);
    this.timerForEvent = setTimeout(function () {
        // 当前tab是数据，则请求并渲染
        const cur = document.querySelector('.c-slider__item--active');
        if (cur.getAttribute('data-type') == 'eventData') {
            this.renderTo(cur, true);
        }
    }.bind(this), 240000); // 4min
}
sportsEventData.prototype.initEvent = function () {
    this.initEventSta = true;
    // 轮询获取新数据
    this.setTimeForData();
};
sportsEventData.prototype.formatData = function (data) {
    var _this = this;
    var list = data.eventsList || [];
    var hasData = Object.keys(list).length || 0;
    Object.keys(list).forEach(function (key) {
        var timeArr = list[key] || []; // 同时间的事件列表
        // 处理前5个状态的描述
        timeArr.map(function (item) {
            if (item.status && parseInt(item.status) <= 5) {
                var target = _this.eventStatus.filter(function (event) {
                    return event.value == item.status;
                });
                item.desc = target && target.length ? target[0].label : '';
            }
            return item;
        });
        var special = timeArr.filter(function (time) {
            return parseInt(time.status) <= 5;
        }).removeRepeat();// 去重
        special.length > 1 && special.sort((v1, v2) => {
            return parseInt(v1.status) - parseInt(v2.status);
        }); // 小于5的排序

        var left = timeArr.filter(function (item) {
            return item.team && parseInt(item.team) == 0; // 主队
        });
        var right = timeArr.filter(function (item) {
            return item.team && parseInt(item.team) == 1; // 主队
        });
        list[key] = {
            time: key,
            md: special || [],
            left: left || [],
            right: right || []
        };
    })
    return {
        list: list,
        hasData: hasData
    };
}
sportsEventData.prototype.initDom = function (result) {
    this.el = $(tmpl({ data: result }));
    return this.el;
}
sportsEventData.prototype.appendChild = function (parentNode, ele) {
    if (ele[0]) {
        if (document.getElementsByClassName('sports-event').length) {
            // 移除之前的
            parentNode.removeChild(document.getElementsByClassName('sports-event')[0]);
        }
        parentNode.insertBefore($(this.el)[0], parentNode.firstChild);
    }
}
sportsEventData.prototype.renderTo = function (parentNode, polling) {
    var self = this;
    // 先请求所有事件状态，再请求历史数据
    var request = Promise.resolve(this.requestEventStatus());
    request.then(function (data) {
        // console.log('requestEventStatus---data', data);
        if (data && data.code == 0) {
            // 记录所有事件状态
            self.eventStatus = data.data;
            return data.data;
        } else {
            throw new Error(data.message);
        }
    }).then(() => this.requestData())
        .then(function (data) {
            // console.log('requestData---data-', data);
            if (data && data.code == 0) {
                var newData = self.formatData(data.data || {});
                var ele = self.initDom(newData);
                self.appendChild(parentNode, ele);
                // parentNode.appendChild(ele[0]);
                !self.initEventSta && self.initEvent(); // 首次初始化
            } else {
                throw new Error(data.message);
            }
            // 返回处理
        }).catch(function (e) {
            // console.log('e', e);
            alert(e);
        }).finally(function () {
            polling && self.setTimeForData(); // 轮询，获取数据
        })

};

module.exports = sportsEventData;




// WEBPACK FOOTER //
// ./app/modules/eventData/index.js